import React from 'react';

import { NextPageContext } from 'next';
import { captureException } from '@sentry/hub';

import { ErrorPage } from '@modules/pages/error';

type Props = {
  statusCode?: number;
  error?: Error;
};

const ErrorPageWrapper = ({ statusCode, error }: Props) => (
  <ErrorPage statusCode={statusCode} error={error} />
);

ErrorPageWrapper.getInitialProps = ({ res, err }: NextPageContext) => {
  const errorCode = err && err.statusCode;
  const resCode = res && res.statusCode;
  const statusCode = errorCode || resCode;

  if (err) {
    // Delete circular properties
    delete (err as any).request;
    delete (err as any).response;
  }

  if (res && statusCode === 404) res.statusCode = 404;

  return { statusCode, error: err };
};

export class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    captureException({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage statusCode={500} />;
    }

    return this.props.children;
  }
}

export default ErrorPageWrapper;
